import { Checkbox, List, ListItem, ListItemPrefix, Typography } from "@material-tailwind/react";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid
import { arrayRemove, arrayUnion, doc, setDoc } from "firebase/firestore";
import "react-datepicker/dist/react-datepicker.css";
import db from "../../firebase";
import { UserAuth } from "../../context/AuthContext";
import { useContext, useMemo, useState } from "react";
import { ListingViewContext } from "../../context/ListingViewContext";
import { DataContext } from "../../context/DataContext";

export function ColumnChooser({version}) {

  const dataContext = useContext(DataContext);
  const { user } = UserAuth();
  const userCustomData = dataContext.getCustomUserData();
  const listingViewContext = useContext(ListingViewContext);
  const cds = useMemo(()=>[...listingViewContext.colDefs], [listingViewContext]);
  const [colDefs] = useState(cds);

  const fieldChecked = async (e, field) =>{
    const docRef = doc(db, "user_layout", user.uid);
    const updateObj = {};
    updateObj[version] = !e.target.checked ? arrayUnion(field) : arrayRemove(field)
    await setDoc(docRef, updateObj, {merge:true});
  }

  if (!userCustomData){
    return <div>Loading</div>
  }

  const isDefaultChecked = (field) =>{
    if (userCustomData && userCustomData.data() && userCustomData.data()[version] 
          && !userCustomData.data()[version].includes(field)){
            return true
          }
    else {
      if (!userCustomData || !userCustomData.data() || !userCustomData.data()[version]){
        return true;
      }
    }
    
  }

  return (
    

      <List>
      {colDefs && colDefs.map((c, index)=>
            
          <ListItem className="p-0" key={`list-item-${index}`}>
            <label
              htmlFor="vertical-list-react"
              className="flex w-full cursor-pointer items-center px-3 py-2"
            >
              <ListItemPrefix className="mr-3">
                <Checkbox
                  id={`vertical-list-${index}`}
                  ripple={false}
                  className="hover:before:opacity-0"
                  containerProps={{
                    className: "p-0",
                  }}
                  defaultChecked={isDefaultChecked(c.field)}
                  onClick={(e) => fieldChecked(e, c.field)}
                />
              </ListItemPrefix>
              <Typography color="blue-gray" className="font-medium">
              {c.headerName ? c.headerName: `${c.field} **`}
              </Typography>
            </label>
        </ListItem>
      )}
      </List>
    
  );
}

export default ColumnChooser;
